import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";
import { SentryErrorBoundary } from "@/components/SentryErrorBoundary";

// Bootstrap Sentry as the FIRST thing we do — before App renders so even
// errors thrown by top-level imports / context providers get captured.
initSentry();

// Disable browser-managed scroll restoration. iOS Safari aggressively restores
// the previous page's scrollY after navigation/login which manifests as the
// app loading "scrolled down a small bit by default" on iPhones. The shells
// also reset scrollTop=0 on route change, but this prevents the underlying
// iOS behaviour from kicking in in the first place.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
